/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM, useUuid } from "@adapptio/lib-components";
import { FieldListItemContext } from "../../../contexts";

import "./FieldListItem.scss";

export interface IFieldListItemProps {
	children?: React.ReactNode;
	id?: string;
	index?: number;
	className?: string;
	disabled?: boolean;
	onExpandChange?: React.MouseEventHandler;
	expanded?: boolean;
	draggable?: boolean;
	mark?: string;
}

export const FieldListItem = React.forwardRef<HTMLDivElement, IFieldListItemProps>(
	(
		{ children, className, mark, id: propId, index, disabled, onExpandChange, expanded, draggable },
		ref
	) => {
		const baseClass = BEM("edt-field-list-item", null, {
			expanded
		});
		const uuid = useUuid();

		const id = propId || uuid;

		if (className) {
			baseClass.add(className);
		}

		if (mark) {
			baseClass.add("m-" + mark);
		}

		return (
			<FieldListItemContext.Provider
				value={{
					id,
					index,
					disabled,
					expanded,
					onExpandChange,
					draggable
				}}
			>
				<div className={baseClass.toClassName()} ref={ref}>
					{children}
				</div>
			</FieldListItemContext.Provider>
		);
	}
);

FieldListItem.defaultProps = {
	index: 0,
	draggable: false
};
